export default {
  screens: [
    {
      type: 'intro',
      title: 'La Maison Chaumet',
      content:
        "En 1812, Chaumet est la première Maison à s'installer au coeur de la place Vendôme, à l'adresse actuelle du Ritz. La joaillerie parisienne est née.",
      idYt: 'Ksm_iOCcZVE',
      videoCover: 'world/home/video.jpg',
      desktop: {
        cover: 'world/home/cover-1.jpg'
      },
      mobile: {
        cover: 'world/home/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '60%',
          bottom: '-30%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/home/perspectiveLeft.jpg',
      middleImg: 'world/home/perspectiveMiddle.jpg',
      content:
        "C'est en 1907 que Chaumet s'installe à son adresse actuelle, au 12, place Vendôme. L'hôtel particulier abrite le magasin historique, les salons classés, le studio de création et l'atelier de Haute Joaillerie.",
      cover: 'world/home/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/mobile-cover-3.jpg',
        coverStyle: {
          width: '79%',
          bottom: '-27%',
          right: '-4%',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        'Créateur novateur, Marie-Etienne Nitot, fondateur de la Maison, a transmis à ses successeurs son savoir-faire virtuose.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/fr/worlds/home.js